
import React from 'react';
import { Box, Card, Divider, TableBody } from '@mui/material';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Sample from "../../AdminDashboard/Onsite And Offsite/Sample.json";
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Paginator from "../../../toolkit/Paginator";
import RightArrowOpen from "../../../icons/RightArrowOpen.svg";
import Edit from "../../../icons/edit.svg";
import Trash from "../../../icons/trash1.svg";
import Avatar from "../../../icons/Avatar.svg";
import Restoreicon from "../../../icons/Restoreicon.svg";
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { useState, useEffect } from 'react';
import { MenuItem, Typography, InputLabel } from "@mui/material";
import Select from "@mui/material/Select";
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import axios from '../../../utils/fvAxios';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Nodata from "../../Nodata/Nodata";
import { ToastContainer, toast } from 'react-toastify';
import { HasScreenPermissions, HasPermissions } from '../../../utils/Token';
import INFO from '../../commom/RouteUrlInfo.json';
import PER from "../../../utils/Enums.json";
import DownloadIcon from "@mui/icons-material/Download";



export default function BouncedEmails() {

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.action.hover,

        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
            marginBottom: "20px"
        },
    }));
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 50 * 5 + 8,
                width: 200,
            },
        },
    };
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const toastNotify = (message, isSuccess = true) => {
        if (isSuccess) {
            toast.success(message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };


    const [open, setOpen] = useState(false);

    const [BlockedEmailsList, setBlockedEmailsList] = React.useState([]);
    const [spinner, setSpinner] = React.useState(false);
    const [Restrict, setRestrict] = useState("0");
    const [Expiry, setExpiry] = useState("0");


    const [Count, setCount] = useState("");
    const [number, setNumber] = useState("1");
    const [Search, setSearch] = useState("");
    const [SearchDebounce, setSearchDebounce] = useState("");
    const [id, setID] = useState("");
    const [BlockingType, setBlockingType] = useState(0);
    const [BlockingTypeName, setBlockingTypeName] = useState("Domain");
    const [Email, setEmail] = useState("");
    const [EmailName, setEmailName] = useState("");
    const [BlockedEmailId, setBlockedEmailId] = useState(0);
    const [SearchBy, setSearchBy] = useState("2");


    const handleClickOpen = (num, data) => {
        if (num == 2) {
            setBlockingType(data?.type);
            setBlockedEmailId(data?.blockedEmailId);
            setBlockingTypeName(data?.type == 1 ? "Domain" : "Email");
            setEmailName(data?.email?.replace("*@", ""));

        } else {
            setBlockingTypeName(BlockingType == 1 ? "Domain" : "Email");
        }
        setID(num);
        setOpen(true);

    };


    const [error, setError] = useState("");

    const ChangeItem = (value) => {
        value = value.trimStart();
        setEmail(value);

        if (!value) {
            setError("");
            return;
        }

        if (BlockingType == 0) {
            const emailRegex = /^[a-zA-Z0-9_%+-]+(?:\.[a-zA-Z0-9_%+-]+)*@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,20}$/;
            if (!emailRegex.test(value)) {
                setError("Please enter a valid email.");
            } else {
                setError("");
            }
        } else {
            const domainRegex = /^(?!:\/\/)([A-Za-z0-9-]+\.)+[A-Za-z]{2,}$/;
            if (!domainRegex.test(value) || value.includes("@")) {
                setError("Please enter a valid domain.");
            } else {
                setError("");
            }
        }
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            if (Search.length >= 3 || Search.length === 0) {
                setSearchDebounce(Search);
            }
        }, 500);

        return () => clearTimeout(timer);
    }, [Search]);

    const FreeSearch = (e) => {
        handlePageChange("1");
        setSearch(e);
    }

    const handleClose = () => {
        setOpen(false);
        setError("");
        setEmail("");
    };

    const SpinnerClose = () => {
        setSpinner(false);
    };

    const handlePageChange = (event) => {
        setNumber(event);
    };

    async function GetBlockedEmailsList() {
        setSpinner(true);
        const res = await axios.get("SystemUser/GetAllBlockedEmails?pageNumber=" + number + "&pageSize=12" + "&search=" + SearchDebounce + "&searchBy=" + SearchBy);
        setBlockedEmailsList(res?.data?.data);
        setCount(res?.data?.count);
        setSpinner(false);
    }

    useEffect(() => {
        GetBlockedEmailsList();
    }, [number, SearchDebounce, SearchBy]);


    const headers = [
        { label: SearchBy == 0 ? "Email" : SearchBy == 1 ? "Domain" : "Email/Domain", key: "email" },
        { label: "Type", key: "type" },

    ]

    function convertToCSV(data) {
        const header = headers.map(header => `"${header.label}"`).join(',');
        const rows = data?.map(item =>
            headers.map(header => {
                let value = item[header.key];
                if (header.key.toLowerCase() == "email") {
                    value = value?.replace("*@", "");
                }

                if (header.key.toLowerCase() == "type") {
                    value = value == 1 ? "Domain" : "Email";
                }

                return `"${value ?? ""}"`;
            }).join(',')
        );

        return [header, ...rows].join('\n');
    }


    const [downloadLoading, setDownloadLoading] = useState(false);
    const handleDownload = async () => {
        try {
            setDownloadLoading(true);

            const res = await axios.get(
                `SystemUser/GetAllBlockedEmails?pageNumber=1&pageSize=10000&search=${SearchDebounce}&searchBy=${SearchBy}`
            );

            const data = res?.data?.data;

            if (data && data.length > 0) {
                const csvContent = convertToCSV(data);

                const blob = new Blob([csvContent], {
                    type: "text/csv;charset=utf-8;"
                });

                const url = window.URL.createObjectURL(blob);

                const a = document.createElement("a");
                a.href = url;
                a.download = SearchBy == 2 ? "List Of Blocked Emails and Domains.csv" : SearchBy == "0" ? "List Of Blocked Emails.csv" : "List Of Blocked Domains.csv";
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);

                window.URL.revokeObjectURL(url);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setDownloadLoading(false);
        }
    };

    const [Dis, setDis] = useState(false);

    const AddorEditDocument = async () => {
        setDis(true);
        const obj = {
            "blockedEmailId": 0,
            "email": BlockingType == 1
                ? `*@${Email.replace(/^(\*\@|@)/, "")}`
                : Email,
            "type": BlockingType,
            "isBlock": true,
            "message": ""
        }

        const obj1 = {
            "blockedEmailId": BlockedEmailId,
            "email": Email,
            "type": BlockingType,
            "isBlock": false,
            "message": ""
        }

        const Data = id == 1 ? obj : obj1;

        const res = await axios.post("SystemUser/BlockUnblockEmail", Data);
        if (res?.data?.responseCode == 100) {
            toastNotify(res?.data?.responseMessage, true);
            GetBlockedEmailsList();
            handleClose();
            setError("");
            setEmail("");
            setDis(false);
        } else {
            toastNotify(res?.data?.responseMessage, false);
            setOpen(false);
            setDis(false);
        }
    }

    return (
        <>
            <ToastContainer />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={spinner}
                onClick={SpinnerClose}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <Dialog fullScreen={fullScreen} open={open} onClose={handleClose}>
                <DialogTitle
                    sx={{
                        textAlign: "center",
                        fontWeight: 500,
                        fontSize: 20,
                    }}
                >
                    {id == 1 ? `Block ${BlockingType === 0 && id == 1 ? "Email" : "Domain"}` : id == 2 ? `Unblock ${BlockingType === 0 ? "Email" : "Domain"}` : ""}
                </DialogTitle>

                <DialogContent>
                    <Typography align="center">
                        {id == 1
                            ? `Are you sure you want to block this ${BlockingTypeName} : ${Email} ?`
                            : `Are you sure you want to unblock this ${BlockingTypeName} : ${EmailName} ?`}
                    </Typography>
                </DialogContent>

                <DialogActions
                    sx={{
                        justifyContent: "space-between",
                        px: 3,
                        pb: 3,
                    }}
                >
                    <Button
                        variant="outlined"
                        onClick={handleClose}
                        sx={{
                            minWidth: 140,
                            height: 45,
                            textTransform: "none",
                            fontSize: "16px",
                        }}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        onClick={AddorEditDocument}
                        disabled={Dis}
                        sx={{
                            minWidth: 140,
                            height: 45,
                            textTransform: "none",
                            fontSize: "16px",
                        }}
                    >
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>

            <Card style={{ marginBottom: "15px" }}>
                <div style={{ marginLeft: "10px", marginTop: "10px" }}>
                    <div style={{ marginLeft: "15px", marginBottom: "15px" }}>
                        <h3>Block Emails/Domains</h3>
                    </div>
                </div>

                <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085;", height: "2px" }} />

                <div className='mx-3 mt-3 '>

                    <Stack direction={"row"}>
                        <span className='mt-2' style={{ color: "#3E4A62" }}>Block Type: </span>
                        <FormControl>
                            <RadioGroup
                                sx={{ paddingLeft: "120px" }}
                                aria-labelledby="demo-radio-buttons-group-label"
                                name="radio-buttons-group"
                                value={BlockingType}
                                onClick={(e) => {
                                    setBlockingType(e?.target?.value);
                                    setError("");
                                    setEmail("");
                                }}
                            >
                                <Stack direction={"row"} spacing={5}>
                                    <FormControlLabel value={0} control={<Radio />} label="Email" />
                                    <FormControlLabel value={1} control={<Radio />} sx={{ paddingLeft: "15px" }} label="Domain" />
                                </Stack>

                            </RadioGroup>
                        </FormControl>
                    </Stack>
                </div>

                <div className='mx-3 mt-3 mb-4 '>
                    <Stack
                        direction="row"
                        spacing={2}
                        alignItems="center"
                    >
                        <TextField
                            placeholder={BlockingType == 1 ? "Enter Domain" : "Enter Email"}
                            sx={{
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                                fontFamily: "Arial, FontAwesome",
                                width: 300,
                            }}
                            variant="outlined"
                            size="small"
                            value={Email}
                            onChange={(e) => ChangeItem(e.target.value)}
                            error={!!error}
                            helperText={error}
                        />

                        <Button
                            variant="contained"
                            sx={{
                                height: "40px",
                                minWidth: "120px", // optional
                                textTransform: "none",
                            }}
                            disabled={!!error || !Email}
                            onClick={() => handleClickOpen(1, "")}
                        >
                            Add
                        </Button>
                    </Stack>
                </div>
            </Card>

            <Card sx={{ marginTop: "20px" }}>

                <div style={{ marginLeft: "10px", marginTop: "10px" }}>
                    <div style={{ marginLeft: "15px", marginBottom: "15px" }}>
                        <h3>List Of Blocked Emails/Domains</h3>
                    </div>
                </div>

                <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085;", height: "2px" }} />

                <Box>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "15px",
                            marginLeft: "15px",
                            marginTop: "10px",
                            marginBottom: "10px",
                        }}
                    >
                        <TextField
                            placeholder={SearchBy == "2" ? "Search Email or Domain" : (SearchBy == "0" ? "Search Email" : "Search Domain")}
                            size="small"
                            sx={{
                                width: 300,
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                            }}
                            value={Search}
                            onChange={(e) => {
                                FreeSearch(e.target.value);
                            }}
                        />

                        <FormControl size="small" sx={{ width: 180 }}>
                            <InputLabel>Search By</InputLabel>
                            <Select
                                value={SearchBy}
                                label="Search By"
                                sx={{
                                    width: 300
                                }}
                                onChange={(e) => {
                                    setSearchBy(e.target.value);
                                    setSearch("");
                                }}
                            >
                                <MenuItem value="2">Both</MenuItem>
                                <MenuItem value="0">Email</MenuItem>
                                <MenuItem value="1">Domain</MenuItem>

                            </Select>
                        </FormControl>

                        <Button
                            variant="contained"
                            disabled={downloadLoading}
                            onClick={handleDownload}
                            sx={{
                                marginLeft: "auto",
                                marginRight: "15px",
                                height: 40,
                            }}
                            hidden={BlockedEmailsList?.length == 0}
                        >
                            {downloadLoading ? (
                                <CircularProgress size={22} color="inherit" />
                            ) : (
                                <>
                                    <DownloadIcon sx={{ mr: 1 }} />
                                    Download
                                </>
                            )}
                        </Button>
                    </div>

                    {BlockedEmailsList?.length < 1
                        ?
                        <div hidden={spinner}><Nodata /> </div>
                        :
                        <TableContainer component={Paper}>
                            <Table aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>
                                            <span style={{ color: "#667085", fontSize: "16px" }}>
                                                {SearchBy == 0 ? "Email" : SearchBy == 1 ? "Domain" : "Email/Domain"}
                                            </span>
                                        </StyledTableCell>

                                        <StyledTableCell>
                                            <span style={{ color: "#667085", fontSize: "16px" }}>
                                                Type
                                            </span>
                                        </StyledTableCell>

                                        <StyledTableCell />
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {BlockedEmailsList?.length > 0 ? (
                                        BlockedEmailsList.map((r, i) => (
                                            <TableRow key={r.blockedEmailId ?? i}>
                                                <StyledTableCell sx={{ width: "30%" }}>
                                                    {r?.email?.replace("*@", "")}
                                                </StyledTableCell>

                                                <StyledTableCell sx={{ width: "30%" }}>
                                                    {r?.type === 1 ? "Domain" : "Email"}
                                                </StyledTableCell>

                                                <StyledTableCell sx={{ width: "5%" }}>
                                                    <IconButton
                                                        aria-label="unblock"
                                                        onClick={() => handleClickOpen(2, r)}
                                                    >
                                                        <img src={Trash} alt="UnBlock" />
                                                    </IconButton>
                                                </StyledTableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <StyledTableCell colSpan={3} align="center">
                                                No records found
                                            </StyledTableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    }
                </Box >


            </Card >

            <div hidden={BlockedEmailsList == ""}>
                <Paginator
                    count={Math.ceil(Count / 12)}
                    page={Number(number)}
                    margin="18px 0px"
                    onChange={handlePageChange}
                />
            </div>
        </>
    )
}


